import React from "react";
import StarBorderOutlinedIcon from "@mui/icons-material/StarBorderOutlined";
import { ModelElementType } from "@/components/entities";
import { SectionRule } from "components/common/SectionRule";
import { ModelRow } from "./ModelRow";

export const PinnedColumn: React.FC<{ models: ModelElementType[] }> = ({
  models,
}) => (
  <div className="flex-1 min-w-0">
    <SectionRule
      inset
      icon={<StarBorderOutlinedIcon sx={{ fontSize: 14 }} />}
      label="Pinned"
    />
    {models.length === 0 ? (
      <div className="flex items-center gap-2 item-height px-1 text-small text-fg-muted italic">
        <span className="w-5 shrink-0" />
        <span>Star a model to keep it pinned here.</span>
      </div>
    ) : (
      models.map((model) => (
        <ModelRow key={model.model_id} model={model} movable />
      ))
    )}
  </div>
);
